import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset } from '@optimus-web/common';
import { Icon } from '../Icon';
import { getTypographyColor } from '../typography';

export const IconListItem = styled.li`
    display: flex;
    align-items: center;
`;

export const IconListItemIcon = styled(Icon)`
    margin-right: ${getSpacingToken('200')}px;
`;

interface IconListItemLabelProps {
    small?: boolean;
}

export const IconListItemLabel = styled.div<IconListItemLabelProps>`
    word-break: break-word;
    ${(props) => getTextTokenPreset(props.small ? 'bodyMediumStrong' : 'bodyLargeStrong')}
    color: ${getTypographyColor};
`;

interface IconListItemDescriptionProps {
    small?: boolean;
}

export const IconListItemDescription = styled.div<IconListItemDescriptionProps>`
    word-break: break-word;
    ${(props) => getTextTokenPreset(props.small ? 'bodySmall' : 'bodyMedium')};
    color: ${getTypographyColor({ variant: 'secondary' })};
`;
